/*
 * puzzle-vote.js
 *
 * Plain vanilla JS (IIFE), matching assets/bs-business-solutions.js's
 * convention — this feature is NOT the gift-configurator's pure-module/
 * Node-test-harness convention, which is scoped only to that feature.
 *
 * Reads the JSON block snippets/puzzle-vote-data.liquid emits (#pv-data),
 * builds the vote grid, handles selection + submission via fetch(), and
 * hands off to the contact-capture modal (jQuery/Bootstrap 4, like every
 * other modal in this theme) after a successful vote.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pv-root]');
  if (!root) return;

  var dataEl = document.getElementById('pv-data');
  var fatalEl = root.querySelector('[data-pv-fatal]');
  var appEl = root.querySelector('[data-pv-app]');

  var data = null;
  try {
    data = dataEl ? JSON.parse(dataEl.textContent) : null;
  } catch (e) {
    data = null;
  }

  if (!data || (data._errors && data._errors.length) || !data.graphics || !data.graphics.length) {
    if (fatalEl) {
      var msg = (data && data._errors && data._errors.length)
        ? data._errors.join(' ')
        : 'This page is not configured yet.';
      fatalEl.textContent = msg;
      fatalEl.hidden = false;
    }
    return;
  }

  if (appEl) appEl.hidden = false;

  // ISO-8601 week label (e.g. "2026-W38"), computed from the visitor's own
  // clock -- not from a metaobject field. Graphics can now stay live for
  // several weeks without anyone maintaining a "current week" value by hand;
  // the vote-again cutoff and the Sheet's own week grouping (see
  // tools/puzzle-vote/apps-script.js) both derive it from real dates
  // instead. A few hours of skew right at a week boundary (visitor's local
  // time vs. the Sheet's server-clock computation) is an acceptable
  // trade-off for an informal weekly poll -- same "keep it simple" call
  // already made for vote-integrity elsewhere in this file.
  function isoWeekLabel(date) {
    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return d.getUTCFullYear() + '-W' + (weekNo < 10 ? '0' : '') + weekNo;
  }

  var weekId = isoWeekLabel(new Date());
  var dedupKey = 'pv_voted_' + weekId;
  var maxSelectable = typeof data.max_selectable === 'number' ? data.max_selectable : null;

  var gridEl = root.querySelector('[data-pv-grid]');
  var formEl = root.querySelector('[data-pv-form]');
  var counterEl = root.querySelector('[data-pv-counter]');
  var submitEl = root.querySelector('[data-pv-submit]');
  var errorEl = root.querySelector('[data-pv-error]');
  var confirmEl = root.querySelector('[data-pv-confirm]');

  var modalLoadingEl = document.querySelector('[data-pv-modal-loading]');
  var modalAskEl = document.querySelector('[data-pv-modal-ask]');
  var modalSubmittingEl = document.querySelector('[data-pv-modal-submitting]');
  var modalDoneEl = document.querySelector('[data-pv-modal-done]');
  var modalConfettiEl = document.querySelector('[data-pv-contact-confetti]');
  var doneSkipEl = document.querySelector('[data-pv-done-skip]');
  var doneEnteredEl = document.querySelector('[data-pv-done-entered]');

  var reducedMotion = false;
  try {
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function prefersCount() {
    var n = gridEl.querySelectorAll('input[type="checkbox"]:checked').length;
    return n;
  }

  function updateCounter() {
    var n = prefersCount();
    if (counterEl) {
      counterEl.textContent = n === 1 ? '1 selected' : n + ' selected';
    }
    if (submitEl) {
      submitEl.disabled = n === 0;
    }
  }

  function enforceMax(changedInput) {
    if (maxSelectable === null) return;
    var checked = gridEl.querySelectorAll('input[type="checkbox"]:checked');
    if (checked.length > maxSelectable) {
      changedInput.checked = false;
    }
  }

  function buildTile(g) {
    var li = document.createElement('li');

    var label = document.createElement('label');
    label.className = 'pv-tile';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.name = 'pv_vote';
    input.value = g.handle;
    input.setAttribute('data-label', g.label || '');

    var media = document.createElement('span');
    media.className = 'pv-tile__media';
    if (g.image) {
      var img = document.createElement('img');
      img.src = g.image;
      img.alt = g.label || '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    var badge = document.createElement('span');
    badge.className = 'pv-tile__badge';
    media.appendChild(badge);

    var body = document.createElement('span');
    body.className = 'pv-tile__body';
    if (g.label) {
      var h = document.createElement('span');
      h.className = 'pv-tile__label';
      h.textContent = g.label;
      body.appendChild(h);
    }
    if (g.description) {
      var d = document.createElement('span');
      d.className = 'pv-tile__desc';
      d.textContent = g.description;
      body.appendChild(d);
    }

    label.appendChild(input);
    label.appendChild(media);
    label.appendChild(body);
    li.appendChild(label);

    input.addEventListener('change', function () {
      enforceMax(input);
      li.querySelector('.pv-tile').classList.toggle('is-selected', input.checked);
      updateCounter();
    });

    return li;
  }

  function renderConfirmedState() {
    if (formEl) formEl.hidden = true;
    if (confirmEl) confirmEl.hidden = false;
  }

  // Already voted this week on this browser — skip straight to the
  // confirmation state, no server round-trip, no confetti (it already ran).
  var alreadyVoted = false;
  try {
    alreadyVoted = window.localStorage.getItem(dedupKey) === '1';
  } catch (e) {}

  if (alreadyVoted) {
    renderConfirmedState();
    return;
  }

  data.graphics.forEach(function (g) {
    gridEl.appendChild(buildTile(g));
  });
  updateCounter();

  function getOrCreateClientId() {
    var key = 'pv_client_id';
    try {
      var existing = window.localStorage.getItem(key);
      if (existing) return existing;
      var id = 'pv_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      window.localStorage.setItem(key, id);
      return id;
    } catch (e) {
      return 'pv_anon';
    }
  }

  function newId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'id_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  var clientId = getOrCreateClientId();
  var lastVoteId = null;

  function postToAppsScript(payload) {
    // text/plain avoids a CORS preflight the Apps Script Web App cannot
    // answer (no doOptions) — see docs comment in the Apps Script source.
    // Every response is HTTP 200 (a ContentService limitation); the "ok"
    // field in the JSON body is the real success signal, not res.ok.
    //
    // keepalive: true -- without this, a fetch() in flight when the page
    // unloads gets silently aborted by the browser. That's exactly what the
    // contest-entry submission risks: it's the LAST network call in the
    // whole flow, fired right as the "done" state (with its "keep browsing"
    // link) invites the visitor to navigate away or close the tab. Votes
    // rarely hit this because the page stays open through the rest of the
    // modal flow; entries are structurally the request most likely to be
    // cut off mid-flight. keepalive tells the browser to let it finish
    // regardless. (Payloads here are a few hundred bytes, nowhere near the
    // 64KB keepalive body-size ceiling.)
    return fetch(data.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (res) {
      return res.json();
    });
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  // Used only for the contest-entry write (see showModalState's comment) --
  // the vote write stays a single fire-and-forget attempt. Retries with a
  // short, increasing pause between them; 3 attempts total.
  var RETRY_DELAYS_MS = [1000, 2000];

  function postToAppsScriptWithRetry(payload) {
    var attempt = 0;
    function attemptOnce() {
      return postToAppsScript(payload).then(function (res) {
        if (!res || res.ok !== true) {
          throw new Error((res && res.error) || 'write failed');
        }
        return res;
      });
    }
    function tryAgain(err) {
      if (attempt >= RETRY_DELAYS_MS.length) throw err;
      var pause = RETRY_DELAYS_MS[attempt];
      attempt++;
      return wait(pause).then(attemptOnce).catch(tryAgain);
    }
    return attemptOnce().catch(tryAgain);
  }

  function runConfetti() {
    if (reducedMotion || !modalConfettiEl || !modalAskEl) return;
    modalConfettiEl.innerHTML = '';
    var pieces = 14;
    for (var i = 0; i < pieces; i++) {
      var piece = document.createElement('span');
      piece.className = 'pv-confetti__piece';
      var angle = (Math.PI * 2 * i) / pieces + Math.random() * 0.4;
      var distance = 70 + Math.random() * 60;
      var x = Math.round(Math.cos(angle) * distance);
      var y = Math.round(Math.sin(angle) * distance - 40);
      piece.style.setProperty('--pv-confetti-x', x + 'px');
      piece.style.setProperty('--pv-confetti-y', y + 'px');
      modalConfettiEl.appendChild(piece);
    }
    modalAskEl.classList.add('is-bursting');
  }

  // The popup is a single element with four mutually-exclusive states
  // toggled by [hidden] — loading (shown the instant it opens), the reward
  // ask (revealed after a short pause, with the confetti burst), submitting
  // (shown while the contact-entry write, with its retries, is actually in
  // flight), and done (shown once that write is confirmed, or once the
  // visitor skips). See snippets/puzzle-vote-contact-modal.liquid's top
  // comment for why the entry write is blocking while the vote write isn't.
  function showModalState(state) {
    if (modalLoadingEl) modalLoadingEl.hidden = state !== 'loading';
    if (modalAskEl) modalAskEl.hidden = state !== 'ask';
    if (modalSubmittingEl) modalSubmittingEl.hidden = state !== 'submitting';
    if (modalDoneEl) modalDoneEl.hidden = state !== 'done';
  }

  function openContactModal() {
    showModalState('loading');
    if (modalAskEl) modalAskEl.classList.remove('is-bursting');
    if (window.jQuery) {
      window.jQuery('#pv-contact-modal').modal('show');
    }
    // Fixed pause, not tied to the (already-backgrounded) network write —
    // purely pacing so "counting your votes" reads as real, brief work
    // rather than an instant jump-cut. Same "not blocked on network" model
    // as the vote submit itself, just given a moment of visual weight.
    window.setTimeout(function () {
      showModalState('ask');
      runConfetti();
    }, 800);
  }

  if (formEl) {
    formEl.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (errorEl) errorEl.hidden = true;

      var checked = Array.prototype.slice.call(gridEl.querySelectorAll('input[type="checkbox"]:checked'));
      if (!checked.length) return;

      submitEl.disabled = true;

      var voteId = newId();
      var payload = {
        type: 'vote',
        week_identifier: weekId,
        graphics: checked.map(function (i) { return i.value; }),
        graphic_labels: checked.map(function (i) { return i.getAttribute('data-label') || ''; }),
        vote_id: voteId,
        client_id: clientId,
        page_url: window.location.href,
        submitted_at: new Date().toISOString()
      };

      // Optimistic UI: the page settles into its quiet "voted" resting
      // state and the popup opens immediately, without waiting on the
      // network — the vote write to the Google Sheet happens in the
      // background below. A visitor who is offline or whose request fails
      // still sees "thanks for voting"; the failure is logged to the
      // console for diagnosis, not surfaced to them, since reopening the
      // form or showing an error after already saying "thanks" would be a
      // worse experience than the rare silent miss. Deliberate simplicity/
      // reliability tradeoff, not an oversight.
      lastVoteId = voteId;
      try {
        window.localStorage.setItem(dedupKey, '1');
      } catch (e) {}
      renderConfirmedState();
      openContactModal();

      postToAppsScript(payload)
        .then(function (res) {
          if (!res || res.ok !== true) {
            throw new Error((res && res.error) || 'vote write failed');
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line no-console
          console.error('[puzzle-vote] vote submission failed in the background:', err);
        });
    });
  }

  var contactForm = document.querySelector('[data-pv-contact-form]');
  if (contactForm) {
    var contactErrorEl = document.querySelector('[data-pv-contact-error]');
    var contactSubmitEl = document.querySelector('[data-pv-contact-submit]');

    contactForm.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (contactErrorEl) contactErrorEl.hidden = true;

      var nameEl = contactForm.querySelector('[name="name"]');
      var phoneEl = contactForm.querySelector('[name="phone"]');
      var name = nameEl ? nameEl.value.trim() : '';
      var phone = phoneEl ? phoneEl.value.trim() : '';

      if (!name || !phone) {
        if (contactErrorEl) {
          contactErrorEl.textContent = 'Please fill in both fields.';
          contactErrorEl.hidden = false;
        }
        return;
      }

      if (contactSubmitEl) contactSubmitEl.disabled = true;

      var payload = {
        type: 'contest_entry',
        week_identifier: weekId,
        vote_id: lastVoteId,
        name: name,
        phone: phone,
        page_url: window.location.href,
        submitted_at: new Date().toISOString()
      };

      // Unlike the vote submit, this write is BLOCKING: wait for a real
      // answer (with retries) before claiming success. Real-world testing
      // showed entries going missing far more often than votes -- this is
      // the last network call before the visitor is invited to leave, so
      // it was the one most exposed to being cut off mid-flight or lost to
      // a transient failure. The puzzle-piece animation in [data-pv-modal-
      // submitting] covers the wait.
      showModalState('submitting');

      postToAppsScriptWithRetry(payload)
        .then(function () {
          if (doneSkipEl) doneSkipEl.hidden = true;
          if (doneEnteredEl) doneEnteredEl.hidden = false;
          showModalState('done');
        })
        .catch(function (err) {
          // eslint-disable-next-line no-console
          console.error('[puzzle-vote] contest entry submission failed after retries:', err);
          // Back to the form, not a dead end -- name/phone are still filled
          // in, so retrying is just one more tap on the submit button.
          showModalState('ask');
          if (contactSubmitEl) contactSubmitEl.disabled = false;
          if (contactErrorEl) {
            var retryMessage = contactErrorEl.getAttribute('data-retry-message') || "Hmm, that didn't go through. Please try again.";
            contactErrorEl.textContent = retryMessage;
            contactErrorEl.hidden = false;
          }
        });
    });
  }

  var skipBtn = document.querySelector('[data-pv-contact-skip]');
  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      if (doneEnteredEl) doneEnteredEl.hidden = true;
      if (doneSkipEl) doneSkipEl.hidden = false;
      showModalState('done');
    });
  }
})();
